"use strict";

var _slicedToArray = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var validations_1 = require("../../utils/validations");

var MessageRef = /*#__PURE__*/function () {
  function MessageRef(timestamp, sequenceNumber) {
    _classCallCheck(this, MessageRef);

    validations_1.validateIsNotNegativeInteger('timestamp', timestamp);
    validations_1.validateIsNotNegativeInteger('sequenceNumber', sequenceNumber, true);
    this.timestamp = timestamp;
    this.sequenceNumber = sequenceNumber;
  }

  _createClass(MessageRef, [{
    key: "compareTo",
    value: function compareTo(other) {
      if (this.timestamp < other.timestamp) {
        return -1;
      }

      if (this.timestamp > other.timestamp) {
        return 1;
      }

      if (this.sequenceNumber < other.sequenceNumber) {
        return -1;
      }

      if (this.sequenceNumber > other.sequenceNumber) {
        return 1;
      }

      return 0;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      return [this.timestamp, this.sequenceNumber];
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return JSON.stringify(this.toArray());
    }
  }], [{
    key: "fromArray",
    value: function fromArray(arr) {
      var _arr = _slicedToArray(arr, 2),
          timestamp = _arr[0],
          sequenceNumber = _arr[1];

      return new MessageRef(timestamp, sequenceNumber);
    }
  }]);

  return MessageRef;
}();

exports.default = MessageRef;